exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn[data-v-27f3e6f1] {\n  text-wrap: inherit;\n  white-space: inherit;\n}\n.display-2[data-v-27f3e6f1], .display-3[data-v-27f3e6f1] {\n  margin-bottom: 25px;\n  margin-top: 20px;\n}\n", ""]);

// exports
